import CbTableColumn from './src/table-column.vue';

CbTableColumn.install = function(Vue) {
  Vue.component(CbTableColumn.name, CbTableColumn);
};

export default CbTableColumn;
